// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax } from 'components/styles/_media'
import Colors from 'components/styles/colors'

const Breadcrumbs = styled.div`
  padding: 8px;
  background-color: ${Colors.white};
  border-bottom: 1px solid ${Colors.grayE};
  font-size: 10px;
  ${mediaMax.desktop`
    display: none;
  `};
`
const BreadcrumbsItem = styled.li`
  display: inline-block;
  list-style-type: none;
  margin-right: 5px;

  &:not(:first-of-type) {
    &::before {
      margin-right: 5px;
      content: ' > ';
    }
  }
`
const BreadcrumbsItemLink = styled.a`
  color: ${Colors.black};
  &:hover {
    text-decoration: underline;
  }
`

export type PropTypes = {
  breadcrumbs: Array<{
    path: string,
    title: string,
  }>,
}

export default (props: PropTypes) => (
  <Breadcrumbs>
    <ol itemScope itemType="http://data-vocabulary.org/Breadcrumb">
      {props.breadcrumbs.map((item, index) => (
        <BreadcrumbsItem key={index}>
          {item.path && index < props.breadcrumbs.length - 1 ? (
            <BreadcrumbsItemLink href={item.path}>
              <span>{item.title}</span>
            </BreadcrumbsItemLink>
          ) : (
            <span>{item.title}</span>
          )}
        </BreadcrumbsItem>
      ))}
    </ol>
  </Breadcrumbs>
)



// WEBPACK FOOTER //
// ./src/components/shared/Breadcrumbs.jsx